import React from 'react'
import './sort-container.scss'
import { useDynamicList } from 'ahooks'
import useBemClass from '@/utils/hooks/useBEMClass'
import Iconfont from '@/components/iconfont/iconfont'
import { SortableElement, SortableContainer } from 'react-sortable-hoc'
import { Row, Column } from '@/components/layout/layout'
import { Modal } from '@/components/dialog/modal'
import { layerManage } from '@/utils/layer'
import $msg from '@/utils/message'

interface ISortItem {
    name: string
    id: string
    checked: boolean
    onCheck: () => void
}

const SortItem: React.FC<ISortItem> = props => {
    const cls = useBemClass('sort-container')

    return (
        <div className={cls('item')}>
            <Row data-align-items-center>
                <div data-cursor-pointer onClick={props.onCheck}>
                    <Iconfont name={props.checked ? 'iconduoxuanquanxuan-20' : 'iconduoxuanguan-20'} size={20} />
                </div>
                <div data-color-000 data-font-size-16 data-margin-left-16>
                    {props.name}
                </div>
            </Row>
            <div className={cls('item', 'right')}>
                <Iconfont name="icontuodong" size={24} />
            </div>
        </div>
    )
}

const SortItems = SortableElement(SortItem)

type ISortData = Array<{
    name: string
    id: string
    checked: boolean
}>

interface SortContainerProps {
    sortData: ISortData
    onSortEnd: (data: ISortData) => void
}

const SortContainer: React.FC<SortContainerProps> = props => {
    const cls = useBemClass('sort-container')

    const { list, move, replace } = useDynamicList<{
        name: string
        id: string
        checked: boolean
    }>(props.sortData.filter(s => s.id !== 'payment:0'))

    const SortList = SortableContainer(() => (
        <Row className={cls()}>
            {list.map((l, i) => (
                <SortItems
                    key={l.id}
                    index={i}
                    {...l}
                    onCheck={() => {
                        replace(i, {
                            ...list[i],
                            checked: !list[i].checked,
                        })
                    }}
                />
            ))}
        </Row>
    ))

    return (
        <Modal
            type="success"
            isShow
            title="列表条目显示设置"
            onClose={() => layerManage.pop()}
            onCancel={() => layerManage.pop()}
            onConfirm={() => {
                props.onSortEnd([...props.sortData.filter(s => s.id === 'payment:0'), ...list])
                $msg('success', '设置成功')
                layerManage.pop()
            }}
        >
            <Column>
                <div data-color-000 data-font-size-14 data-margin-bottom-16>
                    可以对以下条目进行拖动排序：
                </div>
                <Row data-align-items-center data-height-50>
                    <div
                        data-margin-left-16
                        style={{
                            cursor: 'not-allowed',
                            opacity: 0.4,
                        }}
                    >
                        <Iconfont name="iconduoxuanquanxuan-20" size={20} />
                    </div>
                    <div data-color-000 data-font-size-16 data-margin-left-16>
                        总收款
                    </div>
                </Row>
                <div className={cls('list')}>
                    <SortList
                        distance={10}
                        axis="xy"
                        onSortEnd={({ oldIndex, newIndex }) => {
                            move(oldIndex, newIndex)
                        }}
                        helperClass="paymode-sort-helper"
                    />
                </div>
            </Column>
        </Modal>
    )
}

export default SortContainer
